module.exports = __webpack_public_path__ + "static/img/053 1.fc31b523.jpg";